import "./common/common.css";
import "./static/iconfont.css";
import imgAndroid from "./assets/app-face.png";
import androidApk from "./assets/next2you104.apk";
const androidVersion = 100
const packageName = 'com.zhipu.next2you'
const stores = {
  'XIAOMI': {
    test: /([^a-zA-Z]Mi |Redmi)/i, // /((?<![a-zA-Z])Mi |Redmi)/i
    scheme: "mimarket://details?id=<PackageName>",
    name: '小米商城'
  },
  // 'REDMI': {
  //   test: /(Redmi)/,
  //   scheme: "mimarket://details?id=<PackageName>",
  //   name: '小米商城'
  // },
  'HUAWEI': {
    test: /Huawei/i,
    scheme: "appmarket://details?id=<PackageName>",
    name: '华为商城'
  },
  // "VIVO": {
  //   test: /vivo/i,
  //   scheme: "vivoMarket://details?id=<PackageName>",
  //   name: 'vivo 商城'
  // },
  // "OPPO": {
  //   test: /oppo/i,
  //   scheme: "vivoMarket://details?id=<PackageName>",
  //   name: 'vivo 商城'
  // }
}

// document.querySelector('.ua').textContent = `UA: ${window.navigator.userAgent}`
document.querySelector("img.android-page").src = imgAndroid;

window.onload = () => {
  // console.log('onload')
  let androidDEl = document.querySelector(".banner__download-item.android");
  let iosDEl = document.querySelector(".banner__download-item.ios");
  var os = (function () {
    var ua = navigator.userAgent,
      isWindowsPhone = /(?:Windows Phone)/.test(ua),
      isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isTablet =
        /(?:iPad|PlayBook)/.test(ua) ||
        (isAndroid && !/(?:Mobile)/.test(ua)) ||
        (isFireFox && /(?:Tablet)/.test(ua)),
      isPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isPc = !isPhone && !isAndroid && !isSymbian;
    return {
      isTablet: isTablet,
      isPhone: isPhone,
      isAndroid: isAndroid,
      isPc: isPc,
    };
  })();
  androidDEl.setAttribute("href", androidApk);
  if (os.isAndroid) {
    // alert('is android or pc')
    iosDEl.style.display = "none"
    detectPhoneBrand()
  } else if (os.isPhone) {
    // console.log('hide icon', androidDEl)
    // androidDEl.setAttribute('di', true)
    androidDEl.style.display = "none";
  }
  let inWx = /(?:MicroMessenger)/i;
  if (inWx.test(navigator.userAgent)) {
    console.log("in wx");
    showToptips("点击右上角在浏览器中打开安装↗︎");
  }
  fetchApkList().then(res => {
    let { android } = res;
    if (android && android.url) {
      androidDEl.setAttribute("href", android.url);
    }
  }, err => {
    console.warn(err)
  })

  // document.querySelector('.ua').textContent = window.navigator.userAgent
};

function showToptips(msg) {
  let el = document.querySelector(".toptips");
  if (el) {
    el.textContent = String(msg);
    el.style.display = "block";
  }
}

function hideToptips() {
  let el = document.querySelector(".toptips");
  if (el) {
    // el.textContent = String(msg)
    el.style.display = "none";
  }
}

async function fetchApkList() {
  let response = await fetch('fetchlist.json')
  let list = await response.json()
  return list
}

function detectPhoneBrand() {
  let ua = window.navigator.userAgent
  let names = []
  for (let key in stores) {
    let brand = stores[key]
    names.push(brand.name)
    if (brand.test && brand.test.test(ua)) {
      // console.log('match')
      appenLink(brand.scheme.replace('<PackageName>', packageName), brand.name)
    }
  }
  // console.log(names)
  let hintEl = document.querySelector('.hint')
  if (names.length && hintEl) {
    hintEl.textContent = `目前应用已在：${names.join('、')}中上架，您可点击链接或自行前往商店搜索'如在身边'进行下载安装。`
  }
}

/**
 * 
 * @param {string} href 跳转href: 应用商店 
 * @param {string} name 商店名
 * @returns 
 */
function appenLink(href, name) {
  let parent = document.querySelector('.banner__download')
  if (!parent) {
    return
  }
  let a = document.createElement('a')
  let i = document.createElement('i')
  let span = document.createElement('span')
  i.className = 'iconfont icon-android1'
  span.textContent = name
  a.href = href
  a.className = 'banner__download-item'
  a.appendChild(i)
  a.appendChild(span)
  // parent.appendChild(a)
  parent.insertBefore(a, parent.firstChild)
  return a
}
